<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.gmovement") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ $t("content.item") }}</th>
                      <th class="text-center">{{ $t("content.more12m") }}</th>
                      <th v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                        {{ month.Label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- แถวข้อมูลปกติ (จำนำ, ต่อดอก, ..., ของหลุด) -->
                    <tr v-for="(row, index) in rows" :key="index">
                      <td class="text-left">{{ row.name }}</td>
                      <td class="text-center">{{ formatNumberString(apiData?.['00000']?.[row.apiKey]) }}</td>
                      <td v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                        <!-- เงื่อนไข: ต้องมีค่า > 0 และ apiKey ต้องไม่ใช่ inout ถึงจะคลิกได้ -->
                        <span 
                          v-if="apiData?.[month.Value]?.[row.apiKey] > 0 && row.apiKey !== 'inout'"
                          class="font-weight-bold" 
                          style="cursor:pointer; text-decoration:underline;color: blue;"
                          @click="goToHistory(month.Value, row)"
                        >
                          {{ formatNumberString(apiData?.[month.Value]?.[row.apiKey]) }}
                        </span>

                        <!-- กรณีเป็น inout หรือค่าเป็น 0 ให้โชว์ตัวเลขเฉยๆ (คลิกไม่ได้) -->
                        <span v-else>
                          {{ fmNumber(apiData?.[month.Value]?.[row.apiKey]) }}
                        </span>
                      </td>
                    </tr>

                    <!-- แถวพิเศษ: % ของผลัด -->
                    <tr class="table-secondary font-weight-bold">
                      <td class="text-left">% ของผลัด</td>
                      <td class="text-center">
                        {{ calculatePercent(apiData?.['00000']?.postpone, apiData?.['00000']?.pawn) }}
                      </td>
                      <td v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                        {{ calculatePercent(apiData?.[month.Value]?.postpone, apiData?.[month.Value]?.pawn) }}
                      </td>
                    </tr>

                    <!-- แถวพิเศษ: % ของหลุด -->
                    <tr class="table-secondary font-weight-bold">
                      <td class="text-left">% ของหลุด</td>
                      <td class="text-center">
                        {{ calculatePercent(apiData?.['00000']?.breaking, apiData?.['00000']?.pawn) }}
                      </td>
                      <td v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                        {{ calculatePercent(apiData?.[month.Value]?.breaking, apiData?.[month.Value]?.pawn) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import MaterialButton from "@/components/MaterialButton.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

import { useStockMovementStore } from '@/stores/stockmovement';

const storest = useStockMovementStore()

const { t } = useI18n();
const swal = inject("$swal");
const apiData = ref({});
const rows = [
  { name: 'จำนำ', apiKey: 'pawn' },
  { name: 'ต่อดอก', apiKey: 'interest' },
  { name: 'เพิ่มต้น', apiKey: 'incPrinciple' },
  { name: 'ลดต้น', apiKey: 'decPrinciple' },
  { name: 'ไถ่ถอน (ทำธุรกรรมใหม่)', apiKey: 'redeemNewTx' },
  { name: 'ไถ่ถอนจริง', apiKey: 'redeem' },
  { name: 'จำนวนตั๋วที่เหลือตามวันที่ทำธุรกรรมของเดือนนั้นๆ', apiKey: 'remaining' },
  { name: 'จำนวนตั๋วที่เข้าออกของเดือนนั้นๆ', apiKey: 'inout' },
  { name: 'อายัด', apiKey: 'freeze' },
  { name: 'ของผลัด', apiKey: 'postpone' },
  { name: 'ของหลุด', apiKey: 'breaking' },
];

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const dynamicMonths = computed(() => {
  const months = [];
  const now = new Date();
  for (let i = 11; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = `${d.toLocaleString('th-TH', { month: 'short' })}-${d.getFullYear().toString().slice(-2)}`;
    const monthVal = d.getMonth() + 1;
    const value = `${d.getFullYear()}${monthVal.toString().padStart(2, '0')}`;
    months.push({ Label: label, Value: value });
  }
  return months;
});


const calculatePercent = (value, pawn) => {
  if (!value || !pawn || pawn === 0 || value <= 0) return ''; // ถ้าค่าเป็น 0 ไม่ต้องโชว์ %
  return ((value / pawn) * 100).toFixed(2) + '%';
};

const loadDataReportApi = async () => {
  apiData.value = {}
  let data = "";

  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storest.txSummaryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
            if (response.data && response.data.data) {
              apiData.value = response.data.data;
            } 
      }
    }
  }
}

loadDataReportApi()

function formatNumberString(num) {
  if (num && num > 0) {
    return num.toLocaleString();
  }
  return ''; // หรือใส่ '-' ถ้าต้องการให้เห็นขีดแทนช่องว่าง
}

function fmNumber(num) {
 if (num && num !== 0) {
    return num.toLocaleString();
  }
  return '';
}

const goToHistory = (monthValue, row) => {
  const start = moment(monthValue, "YYYYMM").startOf('month').format('YYYY-MM-DDT00:00:00');
  const end = moment(monthValue, "YYYYMM").endOf('month').format('YYYY-MM-DDT23:59:59');

  const valueMap = {
    'pawn': 3, 'interest': 4, 'incPrinciple': 5, 'decPrinciple': 6, 'redeem': 7,
    'redeemNewTx': 21, 'remaining': 22, 'freeze': 23, 'postpone': 24, 'breaking': 25
  };

  const data = {
    start_date: start,
    end_date: end,
    value: valueMap[row.apiKey] || 0
  };

  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  window.location.assign("#/generals/history");
};

</script>
  
<style lang="scss" scoped>

</style>